import React, { useEffect, useState, useRef } from 'react'
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  Toolbar,
  Typography,
} from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import Container from '@mui/material/Container'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../reducers'
import { SelectChangeEvent } from '@mui/material/Select'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { Check as CheckIcon, Clear as ClearIcon } from '@mui/icons-material'
import FeedIcon from '@mui/icons-material/Feed'
import Tooltip from '@mui/material/Tooltip'
import { addListData, getDraftReportData, getBarcodeData } from '../../actions'
import { alpha } from '@mui/material/styles'
const useStyles = makeStyles((theme) => ({
  appBar: {
    color: '#0A688D',
    backgroundColor: '#f2f2f2',
  },
  backToInbox: {
    width: '119px',
    height: '26px',
    padding: '2px 2px 2px 2px',
    boxSizing: 'border-box',
    fontFamily: 'Open Sans',
    textAlign: 'center',
    lineHeight: 'normal',
  },
  navlinks: {
    marginLeft: theme.spacing(2),
    display: 'flex',
  },
  pageTitle: {
    fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
    fontSize: '20px',
    // width: '100%',
    paddingTop: '10px',
    fontWeight: 'bold',
    marginLeft: '20px',
  },
  pageTitleStain: {
    fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
    fontSize: '20px',
    // width: '100%',
    paddingTop: '10px',
    fontWeight: 'bold',
    marginLeft: '20px',
    paddingLeft: '150px',
  },
  link: {
    textDecoration: 'none',
    color: '#fff !important',
    fontSize: '16px',
    marginLeft: '10px',
    marginTop: '10px',
    padding: '5px',
    marginBottom: '3px',
    minWidth: '40px',
    height: '35px',
    borderRadius: '5px',
    float: 'left',
    borderColor: '#fff',
    backgroundColor: 'rgba(10, 104, 141, 1)',
    '&:first-child': {
      marginLeft: '0',
    },
    cursor: 'pointer',
    '&:hover': {
      outline: '0px !important',
      backgroundColor: '#0a688d',
      color: '#fff',
    },
    '&:focus': {
      outline: '0px !important',
      backgroundColor: '#0a688d',
      color: '#fff',
    },
  },
  diagnosisNavbar: {
    width: '100%',
    marginLeft: '0px',
    marginRight: '0px',
    color: '#0A688D',
  },
  navbarDropdown: {
    marginLeft: '10px',
    marginTop: '10px',
    minWidth: 200,
    color: '#0A688D',
    float: 'left',
    maxWidth: 270,
    fontSize: '16px !important',
  },
  navbarTitle: {
    float: 'left',
    fontSize: '16px',
    padding: '2px 3px',
    marginLeft: '20px',
  },
  buttonMargin: {
    marginLeft: '10px',
  },
  discardDialogHeight: {
    height: '180px',
  },
  discardDialogContent: {
    display: 'flex',
    justifyContent: 'left',
    marginTop: '20px',
  },
  dialogTitle: {
    backgroundColor: '#0A688D',
    color: '#FFF',
  },
  buttonActions: {
    borderTop: '1px solid #d3d3d3',
    marginRight: '8px',
    paddingTop: '8px',
    marginTop: '8px',
  },
  saveButton: {
    width: '144px',
    height: '40px',
    padding: '2px 2px 2px 2px',
    borderRadius: '5px',
    backgroundColor: '#0a688d',
    boxSizing: 'border-box',
    color: '#ffffff',
    textAlign: 'center',
    marginLeft: '10px',
    float: 'right',
    '&:hover': {
      outline: '0px !important',
      backgroundColor: '#0A688D',
      color: '#fff',
      // boxShadow: '0 0 0 0.2rem #333',
    },
    '&:focus': {
      outline: '0px !important',
      backgroundColor: '#0A688D',
      color: '#fff',
      // boxShadow: '0 0 0 0.2rem #333',
    },
  },
  diagnosedStainName: {
    textAlign: 'center',
    color: '#0A688D',
    cursor: 'pointer',
  },
  notDiagnosedStainName: {
    textAlign: 'center',
    color: 'orange',
    cursor: 'pointer',
  },
  disabledStainName: {
    textAlign: 'center',
    color: '#797979',
    fontWeight: 'bolder',
    pointerEvents: 'none',
  },
  dontReportStainName: {
    textAlign: 'center',
    color: '#C41E3A',
    cursor: 'pointer',
  },
}))

export function DiagnosisNavbar({
  caseView,
  handleSummaryOpen,
  handleViewerOpen,
  handleReportOpen,
  stainsDropdown,
  handlePremerisClose,
  isSummary,
  isViewer,
  isReport,
  trfBarcode,
  location,
  slide,
  stain,
  url,
  handleClassifierSelectedValue,
  barcodeError,
  setBarcodeError,
}): JSX.Element | null {
  const classes = useStyles()
  const dispatch = useDispatch()
  const [stainData, setStainData] = useState(stainsDropdown)
  const sampleData = useSelector((state: RootState) => state.addSampleLocationData)
  const saveState = useSelector((state: RootState) => state.getSaveState)
  const { role, multiple_classifiers_allowed } = useSelector((state: RootState) => state.userLogin)
  const [selectedLocation, setSelectedLocation] = useState(location)
  const [changedLocation, setChangedLocation] = useState('')
  const [header, setHeader] = useState('')
  const [selectedStain, setSelectedStain] = useState('')
  const [isLocationChanged, setLocationChanged] = useState(false)
  const [isConfirmDialogOpen, setConfirmDialogOpen] = useState(false)
  const barcodeData = useSelector((state: RootState) => state.addBarcodeData)
  const [selectedClassifierValue, setSelectedClassifierValue] = useState('default')

  useEffect(() => {
    if (stain) {
      if (barcodeData?.data?.versions) {
        const defaultVersion = barcodeData.data.versions.find((v) => v === 'default')
        const validVersion = defaultVersion || barcodeData.data.versions.find((v) => v)
        setSelectedClassifierValue(validVersion)
        handleClassifierSelectedValue(validVersion)
      }
    }
  }, [stain, barcodeData])

  const onSelectTab = (val) => {
    if (isReport && saveState && saveState.payload === false && role !== 'NL_WOMA_ADMIN') {
      setHeader('CaseSummary')
      setConfirmDialogOpen(true)
    } else {
      handleSummaryOpen()
    }
  }

  const getLabelValue = () => {
    if (caseView === 'assigned' && role === 'NL_Pathologist') {
      return 'Back to Inbox [ASSIGNED TO ME]'
    } else if (caseView === 'completed') {
      return 'Back to Inbox [COMPLETED]'
    } else if (caseView === 'ready_for_pickup') {
      return 'Back to Inbox [READY FOR PICKUP]'
    } else if (caseView === 'in_progress') {
      return 'Back to Inbox [IN PROGRESS]'
    } else if (caseView === 'dispatch') {
      return 'Back to Inbox [DISPATCH]'
    } else if (caseView === 'assigned') {
      return 'Back to Inbox [ASSIGNED]'
    } else if (caseView === 'unassigned') {
      return 'Back to Inbox [UNASSIGNED]'
    }
  }

  const onInboxClick = async () => {
    if (isReport && saveState && saveState.payload === false && role !== 'NL_WOMA_ADMIN') {
      setHeader('Inbox')
      setConfirmDialogOpen(true)
    } else {
      handlePremerisClose()
    }
  }

  const handleConfirm = async () => {
    setConfirmDialogOpen(false)
    if (header === 'CaseSummary') {
      handleSummaryOpen()
    } else if (header === 'Inbox') {
      handlePremerisClose()
    } else if (header === 'Location') {
      setSelectedLocation(changedLocation)
      await dispatch(getDraftReportData({ trfBarcode: trfBarcode }))
      handleReportOpen({
        location: changedLocation,
      })
      setSelectedLocation('')
    }
  }
  useEffect(() => {
    if (location && slide && stain) {
      setSelectedStain(slide + ' ' + stain.toUpperCase())
      setSelectedLocation(location)
    }
    if (barcodeData?.data?.versions) {
      // First try to find the default version
      const defaultVersion = barcodeData.data.versions.find((v) => v === 'default')

      // If no default found, use first valid version
      const validVersion = defaultVersion || barcodeData.data.versions.find((v) => v)

      if (validVersion && (!selectedClassifierValue || selectedClassifierValue === 'default')) {
        setSelectedClassifierValue(validVersion)
        handleClassifierSelectedValue(validVersion)
      }
    }
  }, [location, slide, stain, stainsDropdown, barcodeData])

  useEffect(() => {
    if (selectedLocation) {
      const stainsList = getStainData(selectedLocation)
      setStainData(stainsList)
      setSelectedStain(stainsList[0].name)
    }
  }, [selectedLocation, isLocationChanged])

  const getStainData = (selectedLocation) => {
    const currentLocationData = sampleData['payload'].filter((item) => item.location === selectedLocation)
    const currentLocation = currentLocationData[0]
    const stains: any[] = []
    if (currentLocation && currentLocation.children && currentLocation.children.length > 0) {
      currentLocation.children.map((slide) => {
        if (
          slide.type === 'expandable' &&
          slide.children &&
          slide.children.length > 0 &&
          slide.children[0].type === 'expandable' &&
          slide.children[0].children.length > 0
        ) {
          slide.children[0].children?.map((subChild, index1) => {
            const name =
              subChild.sampleBarcode +
              ' ' +
              (subChild.sampleStain ? subChild.sampleStain : subChild.children[0].sampleStain)
            const type = subChild.type
            const isDiagnosed = subChild.isDiagnosed === null ? false : subChild.isDiagnosed
            const isDontReport = subChild.isDontReport === null ? false : subChild.isDontReport
            stains.push({
              name: name,
              type: type,
              isDiagnosed: isDiagnosed,
              isDontReport: isDontReport,
            })
          })
        } else if (slide.type === 'expandable' && slide.children && slide.children.length > 0) {
          slide.children?.map((subChild, index2) => {
            const name = subChild.sampleBarcode + ' ' + subChild.sampleStain
            const type = subChild.type
            const isDiagnosed = subChild.isDiagnosed === null ? false : subChild.isDiagnosed
            const isDontReport = subChild.isDontReport === null ? false : subChild.isDontReport
            stains.push({
              name: name,
              type: type,
              isDiagnosed: isDiagnosed,
              isDontReport: isDontReport,
            })
          })
        } else if (slide.type === 'checkbox') {
          const name = slide.sampleBarcode + ' ' + slide.sampleStain
          const type = slide.type
          const isDiagnosed = slide.isDiagnosed === null ? false : slide.isDiagnosed
          const isDontReport = slide.isDontReport === null ? false : slide.isDontReport
          stains.push({
            name: name,
            type: type,
            isDiagnosed: isDiagnosed,
            isDontReport: isDontReport,
          })
        }
      })
    }
    return stains
  }

  useEffect(() => {
    setStainData(stainsDropdown)
  }, [stainsDropdown])

  const handleLocationSelection = async (event: SelectChangeEvent) => {
    const value = event.target.value as string
    setSelectedLocation(value)
    setLocationChanged(true)
    const newStainData = getStainData(value)
    await dispatch(
      getBarcodeData({
        trfBarcode: trfBarcode,
        slide: newStainData[0].name.substring(0, 8),
        multiple_classifiers_allowed: multiple_classifiers_allowed,
      }),
    )
    await handleViewerOpen({
      stain: newStainData[0].name.substring(9),
      slide: newStainData[0].name.substring(0, 8),
      trfBarcode: trfBarcode,
      location: value,
      stainData: newStainData,
      isShow: false,
    })
  }

  const handleStainSelection = async (event: SelectChangeEvent) => {
    const selection = event.target.value as string
    setSelectedStain(selection)
    await dispatch(
      getBarcodeData({
        trfBarcode: trfBarcode,
        slide: selection.substring(0, 8),
        multiple_classifiers_allowed: multiple_classifiers_allowed,
      }),
    )

    if (isViewer) {
      await handleViewerOpen({
        stain: selection.substring(9),
        slide: selection.substring(0, 8),
        trfBarcode: trfBarcode,
        isShow: false,
        location: isLocationChanged ? selectedLocation : location,
        stainData: stainsDropdown,
      })
    }
  }

  const handleClassifierSelection = async (event: SelectChangeEvent) => {
    const newClassifierValue = event.target.value
    setSelectedClassifierValue(newClassifierValue)
    handleClassifierSelectedValue(newClassifierValue)
  }

  const handleReportLocationChange = async (event: SelectChangeEvent) => {
    setHeader('Location')
    const value = event.target.value as string
    if (isReport && saveState && saveState.payload === false && role !== 'NL_WOMA_ADMIN') {
      setChangedLocation(value)
      setConfirmDialogOpen(true)
    } else {
      setConfirmDialogOpen(false)
      setSelectedLocation(value)
      await dispatch(getDraftReportData({ trfBarcode: trfBarcode }))
      handleReportOpen({
        location: value,
      })
      setSelectedLocation('')
    }
  }

  const handleConfirmDialogClose = () => {
    setConfirmDialogOpen(false)
  }

  function findinactiveLocation(sampleLoc) {
    let cancelledCount = 0
    sampleLoc.children.forEach(function (item) {
      if (item.inactiveReason?.toLowerCase() === 'cancelled') {
        cancelledCount++
      }
    })
    if (cancelledCount === sampleLoc.children.length) {
      return true
    }
    return false
  }

  return (
    <>
      <Box boxShadow={1} style={{ marginBottom: '2px', position: 'relative', backgroundColor: '#9bbccc30' }}>
        <Toolbar style={{ paddingLeft: '0px', marginBottom: '5px', position: 'relative' }}>
          <Container className={classes.diagnosisNavbar}>
            <Tooltip title="Back to Inbox" placement="top-start">
              <Button variant="outlined" disableElevation onClick={onInboxClick} className={`${classes.link} active`}>
                <ArrowBackIcon />
              </Button>
            </Tooltip>
            {isViewer && (
              <>
                <Button variant="outlined" disableElevation onClick={onSelectTab} className={classes.link}>
                  {/* <div className={classes.link} onClick={onSelectTab}> */}
                  <Tooltip title="Case summary" placement="top-start">
                    <FeedIcon />
                  </Tooltip>
                  {/* {/* </div> */}
                </Button>

                {sampleData.payload.length > 0 && (
                  <FormControl
                    className={classes.navbarDropdown}
                    sx={{
                      '& .MuiSelect-outlined': {
                        padding: '8px 8px',
                      },
                    }}
                  >
                    <InputLabel id="demo-simple-select-label">Location</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select-standard"
                      defaultValue={selectedLocation ? selectedLocation : location}
                      value={selectedLocation ? selectedLocation : location}
                      label="Location"
                      style={{ color: '#0A688D', borderColor: '#0A688D' }}
                      input={<OutlinedInput label="Location" />}
                      onChange={handleLocationSelection}
                      sx={{ fontSize: '14px' }}
                    >
                      {' '}
                      {sampleData.payload.map((sampleLoc, index) => {
                        const returnvalue = findinactiveLocation(sampleLoc)
                        return (
                          <MenuItem value={sampleLoc?.location} key={index} disabled={returnvalue}>
                            {sampleLoc?.location}
                          </MenuItem>
                        )
                      })}
                    </Select>
                  </FormControl>
                )}
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  {stainsDropdown && stainData && (
                    <>
                      <FormControl
                        className={classes.navbarDropdown}
                        sx={{
                          '& .MuiSelect-outlined': {
                            padding: '8px 8px',
                          },
                        }}
                      >
                        <InputLabel id="demo-simple-select-label">Stain</InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          defaultValue={slide !== '' ? slide + ' ' + stain.toUpperCase() : selectedStain}
                          value={
                            isLocationChanged
                              ? selectedStain
                              : slide !== ''
                              ? slide + ' ' + stain.toUpperCase()
                              : selectedStain
                          }
                          style={{ color: '#0A688D', borderColor: '#0A688D' }}
                          label="Stain"
                          input={<OutlinedInput label="Stain" />}
                          onChange={handleStainSelection}
                          sx={{ fontSize: '14px' }}
                        >
                          {stainData.map((stain, index) => {
                            return (
                              <MenuItem
                                value={stain?.name}
                                key={index}
                                disabled={stain.type === 'disabled' ? true : false}
                                className={
                                  (stain.isDiagnosed === null ? false : stain.isDiagnosed)
                                    ? (stain.isDontReport === null ? false : stain.isDontReport)
                                      ? `${classes.dontReportStainName}`
                                      : `${classes.diagnosedStainName}`
                                    : `${classes.notDiagnosedStainName}`
                                }
                              >
                                {stain?.name}
                              </MenuItem>
                            )
                          })}
                        </Select>
                      </FormControl>

                      {barcodeData?.data?.versions && barcodeData.data.versions.length > 0 && (
                        <FormControl
                          className={classes.navbarDropdown}
                          sx={{
                            '& .MuiSelect-outlined': {
                              padding: '8px 8px',
                            },
                          }}
                        >
                          <InputLabel id="demo-simple-select-label">Classifiers</InputLabel>

                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            defaultValue={(() => {
                              const defaultVersion = barcodeData?.data?.versions?.find((v) => v === 'default')
                              const firstValidVersion = barcodeData?.data?.versions?.find((v) => v)
                              return defaultVersion || firstValidVersion || 'default'
                            })()}
                            value={selectedClassifierValue}
                            onChange={handleClassifierSelection}
                            style={{ color: '#0A688D', borderColor: '#0A688D' }}
                            label="Classifiers"
                            input={<OutlinedInput label="Classifiers" />}
                            sx={{ fontSize: '14px', width: '130px' }}
                          >
                            {multiple_classifiers_allowed
                              ? barcodeData?.data?.versions
                                  ?.filter((version) => version)
                                  .map((version, index) => {
                                    return (
                                      <MenuItem value={version} key={index}>
                                        {version}
                                      </MenuItem>
                                    )
                                  })
                              : barcodeData?.data?.versions
                                  ?.filter((v) => v === 'default')
                                  .map((version, index) => {
                                    return (
                                      <MenuItem value={version} key={index}>
                                        {version}
                                      </MenuItem>
                                    )
                                  })}
                          </Select>
                        </FormControl>
                      )}
                    </>
                  )}
                  {barcodeData?.data?.versions && barcodeData.data.versions.length > 0 ? (
                    <div>
                      <span className={classes.pageTitle}>Stain Images</span>
                    </div>
                  ) : (
                    <div>
                      <span className={classes.pageTitleStain}>Stain Images</span>
                    </div>
                  )}
                </div>
              </>
            )}
            {isReport && (location || selectedLocation) && (
              <>
                <Button variant="outlined" disableElevation onClick={onSelectTab} className={classes.link}>
                  {/* <div className={classes.link} onClick={onSelectTab}> */}
                  <Tooltip title="Case summary" placement="top-start">
                    <FeedIcon />
                  </Tooltip>
                  {/* </div> */}
                </Button>

                <FormControl
                  className={classes.navbarDropdown}
                  sx={{
                    '& .MuiSelect-outlined': {
                      padding: '8px 8px',
                    },
                  }}
                >
                  <InputLabel id="demo-simple-select-label">Location</InputLabel>
                  <Select
                    labelId="demo-simple-select-standard-label"
                    id="demo-simple-select-standard"
                    value={selectedLocation ? selectedLocation : location}
                    defaultValue={selectedLocation ? selectedLocation : location}
                    label="Location"
                    style={{ color: '#0A688D', borderColor: '#0A688D' }}
                    onChange={handleReportLocationChange}
                    input={<OutlinedInput label="Location" />}
                  >
                    {' '}
                    {sampleData.payload.map((sampleLoc, index) => {
                      const returnvalue = findinactiveLocation(sampleLoc)
                      return (
                        <MenuItem value={sampleLoc?.location} key={index} disabled={returnvalue}>
                          {sampleLoc?.location}
                        </MenuItem>
                      )
                    })}
                  </Select>
                </FormControl>
              </>
            )}
          </Container>
        </Toolbar>
        <Dialog
          open={isConfirmDialogOpen}
          onClose={handleConfirmDialogClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          classes={{ paper: classes.discardDialogHeight }}
        >
          <DialogTitle className={classes.dialogTitle}>Discard Changes</DialogTitle>
          <DialogContent className={classes.discardDialogContent}>
            <DialogContentText id="alert-dialog-description">
              You have pending unsaved changes. Do you really want to discard them?
            </DialogContentText>
          </DialogContent>

          <DialogActions className={classes.buttonActions}>
            <Button className={classes.saveButton} onClick={handleConfirm} autoFocus endIcon={<CheckIcon />}>
              Confirm
            </Button>
            <Button
              className={`${classes.buttonMargin}`}
              onClick={handleConfirmDialogClose}
              variant="outlined"
              endIcon={<ClearIcon />}
            >
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
        {isSummary && (
          <div
            style={{
              marginTop: '3px',
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              zIndex: 10,
            }}
          >
            <Typography
              sx={{
                fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
                fontSize: '20px',
                fontWeight: 'bolder',
                color: '#0a688d',
                //backgroundColor:'#0a688d',
                padding: '5px',
              }}
            >
              Case Summary
            </Typography>
          </div>
        )}

        {isReport && (location || selectedLocation) && (
          <div
            style={{
              marginTop: '3px',
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              zIndex: 10,
            }}
          >
            <Typography
              sx={{
                fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
                fontSize: '20px',
                fontWeight: 'bolder',
                color: '#0a688d',
                padding: '5px',
              }}
            >
              Report Builder
            </Typography>
          </div>
        )}
      </Box>
    </>
  )
}
